import { APIPersonalAutoApplicationForm } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';

export const processPolicyChangeFormsData = (
  applicationData: APIPersonalAutoApplicationForm,
): BinderSectionData => {
  const insuranceCoverages = applicationData?.insurance_coverages || [];
  const vehicles = applicationData?.vehicles || [];

  const processedData: any[] = [];

  insuranceCoverages.forEach((coverage, coverageIndex: number) => {
    const policyChangeForms = coverage?.policy_change_forms;

    if (!policyChangeForms) return;

    // Get the corresponding vehicle name
    const vehicle = vehicles[coverageIndex];
    const vehicleName =
      vehicle?.make && vehicle?.model
        ? `${vehicle.make} ${vehicle.model}`
        : `Vehicle ${coverageIndex + 1}`;

    // Process family protection coverage

    processedData.push({
      autoName: vehicleName,
      deductible: 'N/A',
      premium: `$${policyChangeForms.family_protection_coverage.premium}`,
      formType: 'Family Protection Coverage',
    });

    // Process other coverages
    const otherCoverages = policyChangeForms.other_coverages || [];
    otherCoverages.forEach((otherCoverage) => {
      processedData.push({
        autoName: vehicleName,
        deductible: otherCoverage.deductible_limit || 'N/A',
        premium: `$${otherCoverage.premium}`,
        formType: otherCoverage.name || 'Other Coverage',
      });
    });
  });

  return {
    title: 'Policy Change Forms',
    description: 'Review policy modification forms and coverage changes.',
    isValid: true,
    message: null,
    data: {
      forms: processedData,
    },
  };
};
